import React from 'react';
import type { RefObject } from 'react';

import { useTooltipTrigger } from '@react-aria/tooltip';
import { useTooltipTriggerState } from '@react-stately/tooltip';
import type { TooltipTriggerProps } from '@react-types/tooltip';

import Tooltip from './tooltip';
import type { IProps as IToolTip } from './tooltip';

export type { POSITION } from './tooltip';

export interface IProps extends IToolTip {
  delay?: number;
  latchable?: boolean;
}

export const HoverInfo: React.FC<IProps> = ({ delay, latchable, ...props }) => {
  const triggerRef = React.useRef() as RefObject<HTMLButtonElement>;

  const latch = React.useRef(false);

  const baseTriggerProps = React.useMemo<TooltipTriggerProps>(() => {
    return { delay };
  }, [delay]);

  const onClick = React.useCallback((e) => e.preventDefault(), []);

  const state = useTooltipTriggerState(baseTriggerProps);
  const { triggerProps, tooltipProps } = useTooltipTrigger(baseTriggerProps, state, triggerRef);
  const { isOpen } = state;

  React.useEffect(() => {
    if (latchable) {
      latch.current = latch.current || isOpen;
    }
  }, [isOpen, latchable]);

  return (
    <button
      ref={triggerRef}
      {...triggerProps}
      onClick={onClick}
      className="inline-flex ml-1 mr-7 outline-none"
    >
      {props.children}
      {(isOpen || latch.current) && (
        <Tooltip {...(props as Required<IProps>)} {...tooltipProps} state={state} />
      )}
    </button>
  );
};

HoverInfo.defaultProps = {
  delay: 0,
  latchable: false
};
